import { RestaurantResource } from '@menu/Types/Resources/RestaurantResource';
import getSharedData from '@menu/Utils/getSharedData';

export default (): RestaurantResource => getSharedData().restaurant;
